export const csvMimeTypes = [
  "text/x-comma-separated-values",
  "text/x-csv",
  "application/csv",
  "text/comma-separated-values",
  "text/csv",
  "application/x-csv",
];
